import React from 'react';
import Home from './form.jsx'

function App() {
    return ( <
        div className = "App" >
        <
        Home / >
        <
        /div>
    );
}

export default App;